import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import useGoogleOptimize from '@react-hook/google-optimize'
import { EXPERIMENT_ID } from '../utils'

const useTranslationABTest = (text: string, options?: any, fallbackText?: ReactNode): string | ReactNode => {
    const { t, i18n } = useTranslation()
    // Get the current language code
    const languageCode = i18n.language.toLowerCase()
    const variant = useGoogleOptimize(EXPERIMENT_ID, [false, true], 1000)

    if (
        variant === null ||
        variant === false ||
        (!languageCode.startsWith('pt') &&
            !languageCode.startsWith('es') &&
            !languageCode.startsWith('ko') &&
            !languageCode.startsWith('hi'))
    ) {
        return fallbackText || text
    }

    return t(text, options)
}

export default useTranslationABTest
